
import { Component, Vue, Model } from "vue-property-decorator";

//компонент "обертка" для удобного использования ui-dropdown
@Component({
  name: "ui-paid-dropdown"
})
export default class UipaidDropdownComponent extends Vue {
  @Model('onSelected', {type: [String, Number, Boolean, Object, Array]}) value: any | string | number | boolean;
  onSelected(value: any | string | number | boolean) {
    this.$emit('onSelected', value);
  }
  paidOptions = [
    {id: null, name: 'все'},
    {id: true, name: 'платные'},
    {id: false, name: 'бесплатные'}
  ]
}
